var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonusFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.426 6.877a.25.25 0 00.215.379H6.5a.25.25 0 00.2-.1l1.687-2.25a.25.25 0 00-.2-.4H5.991a.25.25 0 00-.215.121l-1.35 2.25zm.551 1.879a.25.25 0 00-.198.402l6.023 7.83a.25.25 0 00.448-.152v-7.83a.25.25 0 00-.25-.25H4.977zm7.773 8.08a.25.25 0 00.448.152l6.023-7.83a.25.25 0 00-.198-.402H13a.25.25 0 00-.25.25v7.83zm6.61-9.58a.25.25 0 00.213-.379l-1.35-2.25a.25.25 0 00-.214-.121h-2.197a.25.25 0 00-.2.4l1.688 2.25a.25.25 0 00.2.1h1.86zm-5.848-2.65a.25.25 0 00-.2-.1h-2.624a.25.25 0 00-.2.1L8.8 6.856a.25.25 0 00.2.4h6a.25.25 0 00.2-.4l-1.688-2.25z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 7.25h4.175L9.295 3H5.616a1 1 0 00-.857.486L2.5 7.25zm.127 1.5l8.63 11.22a.938.938 0 00.043.051V8.75H2.627zM12.8 20.021c.015-.016.029-.034.043-.051l8.63-11.22H12.8v11.271zM21.6 7.25l-2.259-3.764A1 1 0 0018.484 3h-3.68l2.621 4.25H21.6zM13.05 3h-2l-2.5 4.25h7L13.05 3z",
    fill: "currentColor"
  })));
}
SvgBonusFilled.displayName = 'BonusFilled';
export default SvgBonusFilled;